import { Edit, SimpleForm, NumberInput, TextInput, DateInput } from 'react-admin';

export const Tbl_pianiEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <NumberInput source="id" disabled />
      <NumberInput source="gruppoId" />
      <TextInput source="nome" />
      <TextInput source="DescrizioneCompleta" multiline />
      <NumberInput source="maxNumeroSquadre" />
      <NumberInput source="maxInfografiche" />
      <NumberInput source="maxPostGg" />
      <NumberInput source="maxPostWeek" />
      <TextInput source="imgQuality" />
      <NumberInput source="Prezzo" step={0.01} />
      <TextInput source="note" multiline />
      <NumberInput source="flVisibile" />
      <NumberInput source="flAttivo" />
      <NumberInput source="flAnnullato" />
      <NumberInput source="ordinamento" />
      <DateInput source="createdAt" />
      <DateInput source="updatedAt" />
    </SimpleForm>
  </Edit>
);
